export function tabsSlider() {
    const $wrap = $(".tabs-slider-wrap");

    if ($wrap.length) {

        $wrap.each(function () {
            const sliderNav = $(this).find(".tabs-slider-nav");
            const slider = $(this).find(".tabs-slider-content");
            const numberOfSlides = sliderNav.find(".slick-slide").length;
            const noProgress = sliderNav.hasClass("without-progress-bar");

            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                infinite: false,
                // autoplay: true,
                // autoplaySpeed: 10000,
                asNavFor: sliderNav
            });
            sliderNav.slick({
                slidesToScroll: 1,
                variableWidth: true,
                arrows: false,
                infinite: false,
                asNavFor: slider,
                focusOnSelect: true,
                mobileFirst: true,
                dots: true,
                responsive: [
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            variableWidth: false
                        }
                    }
                ]
            }).on("afterChange", function (event, currentSlide, nextSlide) {
                $(".tabs-section").removeClass("animated");
                slider.find(".slick-slide").removeClass("animate");
                slider.find("[data-slick-index=" + nextSlide + "]").addClass("animate");
            });


            // setting for delete progress bar
            if (noProgress) {
                sliderNav.slick("slickSetOption", {
                    "slidesToShow": 2,
                    "dots": false,
                }, true);

                slider.slick("slickSetOption", {
                    "autoplay": false,
                }, true);
            }

            $(window).on("resize", function () {
                let slidesShown = sliderNav.slick("slickGetOption", "slidesToShow");

                if (numberOfSlides < slidesShown) {
                    setTimeout(() => {
                        sliderNav.find(".slick-track").css("transform", "translate3d(0px, 0px, 0px)");
                    }, 100);
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabsSlider.js